import { AxiosError } from 'axios';
import api from '../../../services/api';
import { BehaviorFormRequestProps } from '../types/behavior.type';

export async function editBehaviorRequest(rest: BehaviorFormRequestProps) {
	try {
		const response = await api.put('/behavior', {
			...rest,
		});

		return response.data;
	} catch (error) {
		if (error instanceof AxiosError) {
			throw new Error(error.response?.data?.message);
		} else {
			throw new Error();
		}
	}
}
